<template>
  <div class="solution-page">
    <Header />

    <main>
      <section class="solution-hero">
        <div class="hero-copy">
          <p class="section-kicker">应用方案</p>
          <h1>面向产业供应链的数字化工作台</h1>
          <p>
            将招采、货运、资讯与企业协同能力组合为可落地的业务方案，帮助企业快速完成线上化升级。
          </p>
        </div>
        <div class="hero-image">
          <img src="@/assets/image/方案1.png" alt="应用方案展示" />
        </div>
      </section>

      <section class="solutions">
        <article v-for="solution in solutions" :key="solution.title" class="solution-card">
          <div class="icon-box">
            <img :src="solution.icon" :alt="solution.title" />
          </div>
          <h2>{{ solution.title }}</h2>
          <p>{{ solution.desc }}</p>
          <button type="button">立即体验</button>
        </article>
      </section>
    </main>

    <Footer />
  </div>
</template>

<script>
import Header from "../Header/index.vue";
import Footer from "../Footer/index.vue";

export default {
  name: "AppSolution",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      solutions: [
        {
          icon: require("@/assets/image/icon1.png"),
          title: "招采门户",
          desc: "整合采购公告、询价采购、供应商响应与结果公示，提升采购全流程透明度。",
        },
        {
          icon: require("@/assets/image/icon2.png"),
          title: "数字货运",
          desc: "连接货主、承运商与司机，支持线上派单、合同履约、运输可视化和结算开票。",
        },
        {
          icon: require("@/assets/image/icon3.png"),
          title: "铜价资讯",
          desc: "提供行情信息与产业资讯，帮助企业更及时地判断采购与经营节奏。",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.solution-page {
  min-height: 100vh;
  background: #f6f8fb;
}

.solution-hero {
  display: grid;
  grid-template-columns: minmax(300px, 0.42fr) minmax(420px, 0.58fr);
  gap: clamp(36px, 6vw, 76px);
  align-items: center;
  padding: clamp(64px, 8vw, 112px) clamp(24px, 6vw, 96px);
  background:
    radial-gradient(circle at 82% 12%, rgba(17, 167, 217, 0.16), transparent 28%),
    linear-gradient(135deg, #ffffff 0%, #edf5ff 100%);
}

.section-kicker {
  color: #1268e8;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0;
}

.hero-copy {
  h1 {
    margin-top: 16px;
    color: #101828;
    font-size: clamp(38px, 5vw, 62px);
    line-height: 1.08;
    font-weight: 800;
  }

  p:last-child {
    margin-top: 22px;
    color: #667085;
    font-size: 18px;
    line-height: 1.8;
  }
}

.hero-image {
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  box-shadow: 0 28px 68px rgba(16, 24, 40, 0.14);

  img {
    display: block;
    width: 100%;
    min-height: 360px;
    object-fit: cover;
    object-position: center;
  }
}

.solutions {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  padding: clamp(56px, 7vw, 92px) clamp(24px, 6vw, 96px);
  background: #fff;
}

.solution-card {
  display: flex;
  flex-direction: column;
  min-height: 360px;
  padding: 30px;
  background: #f8fbff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  box-shadow: 0 16px 42px rgba(16, 24, 40, 0.06);

  h2 {
    margin-top: 22px;
    color: #101828;
    font-size: 24px;
    line-height: 1.3;
    font-weight: 800;
  }

  p {
    margin-top: 14px;
    color: #667085;
    font-size: 16px;
    line-height: 1.8;
  }

  button {
    width: 132px;
    height: 42px;
    margin-top: auto;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border: 0;
    border-radius: 6px;
    background: linear-gradient(135deg, #176bff 0%, #11a7d9 100%);
    cursor: pointer;
  }
}

.icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 66px;
  height: 66px;
  background: #eaf3ff;
  border-radius: 8px;

  img {
    display: block;
    width: 38px;
    height: 38px;
    object-fit: contain;
  }
}

@media screen and (max-width: 1080px) {
  .solution-hero,
  .solutions {
    grid-template-columns: 1fr;
  }

  .solution-card {
    min-height: auto;
  }
}

@media screen and (max-width: 640px) {
  .solution-hero,
  .solutions {
    padding-left: 18px;
    padding-right: 18px;
  }

  .hero-image img {
    min-height: 260px;
  }
}
</style>
